import { CheckCircleOutline } from '@portals/icons';
import React from 'react';

import { List, ListItem, ListItemAvatar, ListItemText, ListItemTextProps, ListProps } from '../../components/List/List';
import { TooltipButton } from '../../components/TooltipButton/TooltipButton';
import { Typography } from '../../components/Typography/Typography';
import { slugify } from '../../utilities/slugify';
import { getStyles } from './TopInfoBox.styles';

interface TopInfoBoxProps extends ListProps {
  alternativeHeadline?: string;
  icon?: React.ReactElement;
  children: React.ReactElement[];
  size?: 'small' | 'medium';
  dense?: boolean;
}
export const TopInfoBox: React.FC<TopInfoBoxProps> = ({
  alternativeHeadline,
  icon,
  children,
  size,
  dense = false,
  ...props
}: TopInfoBoxProps) => {
  const styles = getStyles();

  return (
    <>
      {alternativeHeadline ? (
        <Typography id={slugify(alternativeHeadline)} variant="h6" component="div" innerPadding="horizontal">
          {alternativeHeadline}
        </Typography>
      ) : null}
      <List {...props} variant="icon" disablePadding size={size}>
        {React.Children.map(children, (item) => (
          <ListItem key={item.key} sx={dense ? styles.dense : {}}>
            <ListItemAvatar sx={styles.icon}>
              {icon ? icon : <CheckCircleOutline sx={{ color: 'topline.opened' }} />}
            </ListItemAvatar>
            {item}
          </ListItem>
        ))}
      </List>
    </>
  );
};

interface TopInfoBoxItemTextProps extends ListItemTextProps {
  tooltip?: React.ReactNode;
  children: React.ReactNode;
}

const DEFAULT_SECONDARY_TYPOGRAPHY_PROPS = { color: 'inherit', size: 'small' };

export const TopInfoBoxItemText: React.FC<TopInfoBoxItemTextProps> = ({
  tooltip,
  children,
  primaryTypographyProps = DEFAULT_SECONDARY_TYPOGRAPHY_PROPS,
  ...props
}: TopInfoBoxItemTextProps) => {
  const styles = getStyles();
  return (
    <>
      <ListItemText primary={children} primaryTypographyProps={primaryTypographyProps} {...props} sx={styles.text} />
      {tooltip ? <TooltipButton title={tooltip} placement="top-start" /> : null}
    </>
  );
};
